import React from 'react';
import { Box, Heading, Text } from '@chakra-ui/react';

const Templates: React.FC = () => {
  return (
    <Box>
      <Heading size="lg" mb={4} color="white">Email Templates</Heading>
      <Text color="gray.300">
        Email template management interface will be implemented here.
        This will allow creation and management of reusable email templates for customer responses.
      </Text>
    </Box>
  );
};

export default Templates;